module.exports = __webpack_public_path__ + "img/preloader-orders.0d36fd8f.svg";